import { useQuery } from '@pylot-data/hooks/use-query'
import { WISHLIST_QUERY } from '../graphql/wishlistQuery'
import type { RequestInit } from '@vercel/fetch'
import type { SWRConfiguration } from 'swr'
import type { Customer } from '@pylot-data/pylotschema'
import { useUser } from '@corratech/pylot-auth-manager'

export interface OutputInterface {
    customer: Customer
}

export const useWishlist = (
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
) => {
    // We can run wishlist query only when we know that the user is logged in
    useUser({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const pylotToken =
        typeof window !== 'undefined' &&
        window.localStorage.getItem('pylot_token')
    const swrResponse = useQuery<null, OutputInterface>(
        pylotToken ? WISHLIST_QUERY : null,
        null,
        {
            ...swrOptions,
            // The key is already gated on pylotToken; revalidate on mount so a
            // mid-session login (key mounts before isSignedIn resolves) still
            // fetches the wishlist.
            revalidateOnMount: true
        },
        fetchOptions
    )
    const loading = !swrResponse?.data && !swrResponse?.error
    const wishlists = swrResponse?.data?.data?.customer?.wishlists

    const getWishlistById = (id: string) => {
        if (!wishlists?.length) return null
        return wishlists?.find((wishlist) => wishlist?.id === id)
    }

    return {
        loading,
        wishlists,
        getWishlistById,
        ...swrResponse
    }
}
